import { render, staticRenderFns } from "./SummaryTreatment.vue?vue&type=template&id=b7ec301e&scoped=true"
import script from "./SummaryTreatment.vue?vue&type=script&lang=js"
export * from "./SummaryTreatment.vue?vue&type=script&lang=js"
import style0 from "./SummaryTreatment.vue?vue&type=style&index=0&id=b7ec301e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ec301e",
  null
  
)

export default component.exports